import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const createCollaboratorTask = (request) => {
    return vdkEmHappinessPortalApi.post('/collaboratortasks/create', request);
};
const updateCollaboratorTask = (id, request) => {
    return vdkEmHappinessPortalApi.put(`/collaboratortasks/${id}`, request);
};
const getCollaboratorTaskById = (id) => {
    return vdkEmHappinessPortalApi.get(`/collaboratortasks/${id}`);
};
const getAllCollaboratorTasks = () => {
    return vdkEmHappinessPortalApi.get('/collaboratortasks/get-all');
};
const deleteCollaboratorTask = (id) => {
    return vdkEmHappinessPortalApi.delete(`/collaboratortasks/${id}`);
};
const collaboratorTaskAPI = {
    createCollaboratorTask,
    updateCollaboratorTask,
    getCollaboratorTaskById,
    getAllCollaboratorTasks,
    deleteCollaboratorTask
};
export default collaboratorTaskAPI;
